import { useContext, useMemo } from 'react';
import { CapabilitiesContext } from '@trinity/chat-components/components/BrandInsights/context';

/** What the user may do with chat messages, each allowed when the host app doesn't say otherwise. */
export const useChatMessageCapabilities = () => {
  const capabilities = useContext(CapabilitiesContext);
  const canExportChats = capabilities?.canExportChats ?? true;
  const canShareChats = capabilities?.canShareChats ?? true;
  const canCopyMessages = capabilities?.canCopyMessages ?? true;

  return useMemo(
    () => ({ canExportChats, canShareChats, canCopyMessages }),
    [canExportChats, canShareChats, canCopyMessages]
  );
};
